import { render, staticRenderFns } from "./FileLegacy.vue?vue&type=template&id=7f7a68cc&scoped=true"
import script from "./FileLegacy.vue?vue&type=script&lang=js"
export * from "./FileLegacy.vue?vue&type=script&lang=js"
import style0 from "./FileLegacy.vue?vue&type=style&index=0&id=7f7a68cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7a68cc",
  null
  
)

export default component.exports